<template>
<div>
  <el-dialog width="30%" title="提示" :show-close="false" :close-on-click-modal=false  v-model="confirmSaveSort" draggable>
    <span style="font-size: 20px">【{{this.parentData.wujianId}}】物件进行了排序，您是否保存？</span>
    <div style="width: 100%;display: flex;flex-direction: row;align-items: center;justify-content: center;margin-top: 40px;">
      <el-button type="primary"   @click="cancel()">取消</el-button>
      <el-button type="success"  :loading="sortLoading" @click="saveSort()">保存</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
export default {
  name: "MfgMaterialConfirmPrompt",
  props: {
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data(){
    return {
      sortLoading: false,
      confirmSaveSort:true,
    }
  },methods: {
    //保存
    saveSort(){
      this.sortLoading = true
      console.log(this.parentData)
      //保存排序
      this.$axios.post('mfg/materialConfirm/saveSort',this.parentData).then(response => {
        let res = response.data
        if (res.code === 0) {
          this.$message.success("保存成功");
          this.sortLoading = false
          this.setting.$fn.closeWindow();
        }
      }, error => {
        this.$message.error(`保存失败` + error.message);
      })
    },
    //取消保存
    cancel(){
      this.confirmSaveSort = false
      this.setting.$fn.closeWindow();
    },
  }

}
</script>

<style scoped>

</style>